import {gql} from '@apollo/client'

const RULE_FIELDS = `
  id
  weight
  enabled
  dailyCap
  order
  credit
  eligibleUserCount
  leadsToday
  group {
    id
    name
    userCount
  }
  eligibleGroup {
    id
    name
    userCount
  }
`

export const GET_ASSIGNMENT_RULES = gql`
  query pipelineAssignmentRules($pipelineId: ID!) {
    pipelineAssignmentRules(pipelineId: $pipelineId) {
      ${RULE_FIELDS}
    }
  }
`

export const CREATE_ASSIGNMENT_RULE = gql`
  mutation createPipelineAssignmentRule($ruleData: PipelineAssignmentRuleInput!) {
    createPipelineAssignmentRule(ruleData: $ruleData) {
      success
      errors {
        field
        message
      }
      pipelineAssignmentRule {
        ${RULE_FIELDS}
      }
    }
  }
`

export const UPDATE_ASSIGNMENT_RULE = gql`
  mutation updatePipelineAssignmentRule($id: ID!, $ruleData: PipelineAssignmentRuleInput!) {
    updatePipelineAssignmentRule(id: $id, ruleData: $ruleData) {
      success
      errors {
        field
        message
      }
      pipelineAssignmentRule {
        ${RULE_FIELDS}
      }
    }
  }
`

export const DELETE_ASSIGNMENT_RULE = gql`
  mutation deletePipelineAssignmentRule($id: ID!) {
    deletePipelineAssignmentRule(id: $id) {
      success
      errors {
        field
        message
      }
    }
  }
`

export const RESET_ASSIGNMENT_CREDITS = gql`
  mutation resetPipelineAssignmentCredits($pipelineId: ID!) {
    resetPipelineAssignmentCredits(pipelineId: $pipelineId) {
      success
      errors {
        field
        message
      }
    }
  }
`
